import React from "react";
import { Check, Info } from "lucide-react";

/**
 * Success Modal Component
 * Shows success feedback after an action is completed
 */
const SuccessModal = ({
  isOpen,
  onClose,
  title = "Success!",
  message,
  autoRedirectMessage = "Redirecting in a moment...",
  buttonText = "Continue",
}) => {
  if (!isOpen) return null;

  return (
    <div className="flex fixed inset-0 z-50 justify-center items-center p-4">
      <div
        className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm"
        onClick={onClose}
      />
      <div className="relative p-8 w-full max-w-md bg-white rounded-2xl shadow-2xl duration-200 animate-in fade-in-0 zoom-in-95">
        {/* Success Icon */}
        <div className="flex justify-center mb-6">
          <div className="relative">
            <div className="flex justify-center items-center w-20 h-20 bg-gradient-to-br from-green-400 to-green-600 rounded-full shadow-lg animate-bounce">
              <Check className="w-10 h-10 text-white" strokeWidth={3} />
            </div>
            <div className="absolute inset-0 w-20 h-20 bg-green-400 rounded-full opacity-20 animate-ping" />
          </div>
        </div>

        {/* Content */}
        <div className="mb-6 text-center">
          <h3 className="mb-2 text-2xl font-bold text-gray-900">
            {title}
          </h3>
          <p className="text-gray-600">{message}</p>
        </div>

        {/* Info Message */}
        {autoRedirectMessage && (
          <div className="p-4 mb-6 bg-green-50 rounded-xl border border-green-200">
            <div className="flex items-start space-x-3">
              <Info className="w-5 h-5 text-green-600 flex-shrink-0 mt-0.5" />
              <p className="text-sm text-green-800">{autoRedirectMessage}</p>
            </div>
          </div>
        )}

        {/* Close Button */}
        <button
          onClick={onClose}
          className="px-4 py-3 w-full font-semibold text-white bg-gradient-to-r from-green-600 to-green-700 rounded-xl shadow-md transition-all hover:from-green-700 hover:to-green-800 hover:shadow-lg"
        >
          {buttonText}
        </button>
      </div>
    </div>
  );
};

export default SuccessModal;

